import { createReducer, on } from '@ngrx/store';
import { initialStoreState, StoreState } from '../../interfaces/store-interfaces';
import * as StoreActions from './store-actions';

export const storeReducer = createReducer(
  initialStoreState,
  on(
    StoreActions.loadStores,
    (state): StoreState => ({
      ...state,
      loading: true,
      error: null,
    })
  ),
  on(
    StoreActions.loadStoresSuccess,
    (state, { stores }): StoreState => ({
      ...state,
      stores,
      loading: false,
      error: null,
      initialized: true, // Mark as initialized after successful load
    })
  ),
  on(
    StoreActions.loadStoresFailure,
    (state, { error }): StoreState => ({
      ...state,
      loading: false,
      error,
      initialized: true, // Mark as initialized even on failure (we know the load attempt completed)
    })
  ),
  on(
    StoreActions.selectStore,
    (state, { store }): StoreState => ({
      ...state,
      selectedStore: store,
    })
  )
);
